import { Tooltip, TooltipPosition } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { useCallback, useContext, useMemo, useState } from 'react';
import { SessionContext } from '../../context/SessionContext';
import { useCurrentSession } from '../../hooks/chat/useCurrentSession';
import { useSendQuestion } from '../../hooks/chat/useSendQuestion';
import { isFeedbackProvided } from '../FeedbackForm';
import TextareaWithCounter from '../TextAreaWithCounter/TextareaWithCounter';
import styles from './Footer.module.scss';

const cx = classNames.bind(styles);
let shakingTimeout: NodeJS.Timeout | undefined;
let tooltipTimeout: NodeJS.Timeout | undefined;

export default function Footer(): React.ReactElement {
  const { acceptedTerms } = useContext(SessionContext);
  const { history } = useCurrentSession();
  const { send, isLoading } = useSendQuestion();
  const [tootipIsOpened, setTooltipIsOpened] = useState(false);

  const missedFeedback = useMemo(() => {
    return history.some((item) => !isFeedbackProvided(item));
  }, [history]);

  const handleClick = useCallback(() => {
    if (missedFeedback) {
      setTooltipIsOpened(true);
      const el = document.querySelector<HTMLDivElement>('[data-csgenie-feedback-actions="0"]');

      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
        });

        el.classList.add(cx('shaking'));

        if (shakingTimeout) {
          clearTimeout(shakingTimeout);
        }

        if (tooltipTimeout) {
          clearTimeout(tooltipTimeout);
        }

        shakingTimeout = setTimeout(() => {
          el.classList.remove(cx('shaking'));
        }, 1000);

        tooltipTimeout = setTimeout(() => {
          setTooltipIsOpened(false);
        }, 2000);
      }
    }
  }, [missedFeedback]);

  const handleSubmit = useCallback(
    (query: string) => {
      send({ query });
    },
    [send]
  );

  return (
    <div className={cx('body')}>
      <TextareaWithCounter
        maxNumber={500}
        onSubmit={handleSubmit}
        disabled={!acceptedTerms || missedFeedback}
        disabledSubmit={isLoading || !acceptedTerms}
      />
      {missedFeedback ? (
        <Tooltip
          content="Feedback is required for internal beta testers."
          open={tootipIsOpened}
          position={TooltipPosition.BottomCenter}
          trigger={<div className={cx('overlay')} onClick={handleClick} />}
        />
      ) : null}
    </div>
  );
}
